const toggle = (list, v) => (list.includes(v) ? list.filter((x) => x !== v) : [...list, v]);

export const RecycleAgents = ({ agents, count, cfg, setCfg }) => {
  const n = cfg.agents.length;
  const perAgent = n && count ? Math.ceil(count / n) : 0;
  return (
    <div className="rc-field rc-wide" data-testid="recycle-agents">
      <span>
        Commerciaux à servir {n > 0 && (
          <b data-testid="recycle-split-info">
            — {n} commercia{n > 1 ? "ux" : "l"}{count == null ? " : cliquez sur « Calculer » pour voir la part de chacun" : ` : environ ${perAgent.toLocaleString("fr-FR")} prospects chacun${perAgent > 4999 ? " (découpés en listes de 4 999 max)" : ""}`}
          </b>
        )}
      </span>
      <div className="rc-chips rc-agents">
        {agents.map((a) => <button key={a.id} type="button" className={`rc-chip${cfg.agents.includes(a.id) ? " on" : ""}`} onClick={() => setCfg({ ...cfg, agents: toggle(cfg.agents, a.id) })} data-testid={`recycle-agent-${a.id}`}>{a.name}</button>)}
      </div>
      {n > 0 && <button type="button" className="secondary-button" style={{ marginTop: 8, alignSelf: "flex-start" }} onClick={() => setCfg({ ...cfg, agents: [] })} data-testid="recycle-agents-clear">Tout désélectionner</button>}
    </div>
  );
};
